import ButtonGroup from "../../../components/ButtonGroup";
export default function Hero() {
  return (
    <section id="hero_section">
      <div className="container">
        <div className="hero-wrapper">
          <h1>The better way to hire technical-commercial talent</h1>
          <p>
            Essy replaces job boards and cold outreach with real connections -
            linking SaaS and AI companies to vetted Sales Engineers, Solutions
            Architects, Customer Success Engineers, and other
            technical-commercial professionals who actually want to engage.
          </p>
          <p>
            Currently in beta for candidates and open by waitlist for companies.
          </p>
          <p>Join early and help shape the platform</p>
          <ButtonGroup />
        </div>
      </div>
    </section>
  );
}
